import $ from 'jquery';
import BasketService from '../service/BasketService';
import Popup from "../util/Popup";
/**
 * Для работы подарков необходимо на страницу корзины добавить стандартный компонент корзины битрикс с включеным модулем подарков
 * шаблон .default
 */

$('body').on('click', '.catalog-item-add-gift', function() {
    const productName = $(this).find('.catalog-item__title').text().trim();
    $('.sale-products-gift').find('.col-xs-6').each(function (index, element){
        let bxProductName = $(element).find('.product-item-title').text().trim();

        if(bxProductName == productName) {
            $(element).find('.product-item-button-container').find('a')[0].click();
        }
    });

    Popup.hide();
    window.location.reload();
});

$('body').on('click', '.js-add-gift', function() {
    $(this).parent().find('.catalog-item__title').each(function () {
        const productName = $(this).text().trim();

        $('.sale-products-gift').find('.col-xs-6').each(function (index, element){
            let bxProductName = $(element).find('.product-item-title').text().trim();

            if(bxProductName == productName) {
                $(element).find('.product-item-button-container').find('a')[0].click();
            }
        });
    });

    Popup.hide();
    window.location.reload();
});

